var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1156_12008",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 33,
    height: 32
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 32,
    height: 32,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1156_12008)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.167 22.6665H17.8337V14.6665H15.167V22.6665ZM16.5003 11.9998C16.8781 11.9998 17.1948 11.8721 17.4503 11.6165C17.7059 11.3609 17.8337 11.0443 17.8337 10.6665C17.8337 10.2887 17.7059 9.97206 17.4503 9.7165C17.1948 9.46095 16.8781 9.33317 16.5003 9.33317C16.1225 9.33317 15.8059 9.46095 15.5503 9.7165C15.2948 9.97206 15.167 10.2887 15.167 10.6665C15.167 11.0443 15.2948 11.3609 15.5503 11.6165C15.8059 11.8721 16.1225 11.9998 16.5003 11.9998ZM16.5003 29.3332C14.6559 29.3332 12.9225 28.9832 11.3003 28.2832C9.6781 27.5832 8.26699 26.6332 7.06699 25.4332C5.86699 24.2332 4.91699 22.8221 4.21699 21.1998C3.51699 19.5776 3.16699 17.8443 3.16699 15.9998C3.16699 14.1554 3.51699 12.4221 4.21699 10.7998C4.91699 9.17761 5.86699 7.7665 7.06699 6.5665C8.26699 5.3665 9.6781 4.4165 11.3003 3.7165C12.9225 3.0165 14.6559 2.6665 16.5003 2.6665C18.3448 2.6665 20.0781 3.0165 21.7003 3.7165C23.3225 4.4165 24.7337 5.3665 25.9337 6.5665C27.1337 7.7665 28.0837 9.17761 28.7837 10.7998C29.4837 12.4221 29.8337 14.1554 29.8337 15.9998C29.8337 17.8443 29.4837 19.5776 28.7837 21.1998C28.0837 22.8221 27.1337 24.2332 25.9337 25.4332C24.7337 26.6332 23.3225 27.5832 21.7003 28.2832C20.0781 28.9832 18.3448 29.3332 16.5003 29.3332Z",
    fill: "#0460D9"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.75c85176c4cef9e4fba1fdaa6b5cb315.svg";
export { ForwardRef as ReactComponent };